/**
 * The wait a `429` names in its `Retry-After` header.
 *
 * The pure half of the portal's `apps/web-app/src/api/retry-after.ts` (plan-034 VIEW-PKG): the header reading. The
 * portal's ledger that notes a `429`'s header against its request id wraps `fetch` and the API client, so it stays in
 * the portal; the app's gateway reads the header where it holds the answer.
 *
 * The API sends only the delta-seconds form (`Retry-After: 42`). {@link retryAfterSecondOfHeader} reads only that, as the
 * portal always has. {@link retryAfterMsOf} also reads an HTTP-date in the IMF-fixdate form RFC 9110 requires
 * (`Wed, 21 Oct 2026 07:28:00 GMT`), which names an exact instant rather than a guess; anything else is "no wait
 * known".
 */
/** The longest delta-seconds value read: six digits (the portal's bound). */
const DELTA_SECOND = /^\d{1,6}$/;
/** RFC 9110 §5.6.7 IMF-fixdate, the one HTTP-date form a sender must produce. */
const IMF_FIXDATE = /^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), \d{2} (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{4} \d{2}:\d{2}:\d{2} GMT$/;
/** The whole seconds of a delta-seconds `Retry-After`, or `null` for anything else. */
export function retryAfterSecondOfHeader(raw) {
    if (raw === null)
        return null;
    const trimmed = raw.trim();
    if (!DELTA_SECOND.test(trimmed))
        return null;
    return Number(trimmed);
}
/**
 * How many milliseconds from `nowMs` the header asks a client to wait: a delta-seconds value as its milliseconds, an
 * IMF-fixdate as the time left until it (never negative); `null` when there is no header or it is neither form.
 */
export function retryAfterMsOf(header, nowMs) {
    const second = retryAfterSecondOfHeader(header);
    if (second !== null)
        return second * 1000;
    if (header === null)
        return null;
    const trimmed = header.trim();
    if (!IMF_FIXDATE.test(trimmed))
        return null;
    const at = Date.parse(trimmed);
    if (!Number.isFinite(at))
        return null;
    return Math.max(0, at - nowMs);
}
//# sourceMappingURL=retry-after.js.map